import { $api } from "@/utils/fetch.ts";

export const agentsQueryOptions = () =>
	$api.queryOptions("get", "/api/agents", undefined, {
		// `connected` is computed server-side from a 60 s heartbeat window, so it
		// flips without any user action (agent (re)connects, container restarts).
		// Poll well inside that window so the status badge stays live instead of
		// going stale until a manual page refresh — the global default has
		// refetchOnWindowFocus disabled, so nothing else would refresh it.
		refetchInterval: 15000,
	});

export const useCreateAgentMutation = () =>
	$api.useMutation("post", "/api/agents");

export const useRevokeAgentMutation = () =>
	$api.useMutation("delete", "/api/agents/{agentId}");

export const usePingAgentMutation = () =>
	$api.useMutation("post", "/api/agents/{agentId}/ping");
